import noop from 'lib/noop';
import uiEvents, { uiEventTypes } from 'events/ui';
import showCustomMinimizedButton from 'app/dom_mutators/showCustomMinimizedButton';
import { trackWidgetClosed } from 'events/analytics';
import { getIsExistingUser } from 'app/modules';

export default function minimizeWidget(dispatch, getState) {
  const hasAuthenticated = getIsExistingUser(getState());
  const customMinimizedButtonShown = showCustomMinimizedButton(hasAuthenticated);

  dispatch(trackWidgetClosed());
  dispatch({ type: uiEventTypes.WIDGET_MINIMIZE });
  customMinimizedButtonShown ? dispatch(uiEvents.hideWidget()) : noop();
}
